/* Gallery fallback and a link back to the native purchase controls. */
if (!customElements.get('aura-studio-gallery')) {
  customElements.define('aura-studio-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.assets = JSON.parse(this.querySelector('[data-gallery-assets]').textContent);
      this.main = this.querySelector('.aura-studio-gallery__zoom img');
      this.caption = this.querySelector('.aura-studio-gallery__caption');
      this.dialog = this.querySelector('dialog');
      this.onChoice = (event) => {
        if (!event.target.closest('variant-selects') || !this.closest('product-info').contains(event.target)) return;
        this.showOption();
      };
      document.addEventListener('change', this.onChoice);
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('button[data-src]');
        if (thumb) this.showPhoto(thumb);
        if (event.target.closest('.aura-studio-gallery__zoom')) {
          const photo = this.dialog.querySelector('img');
          photo.src = this.main.src; photo.alt = this.main.alt;
          this.dialog.showModal();
        }
        if (event.target.closest('[data-close-photo]') || event.target === this.dialog) this.dialog.close();
      });
    }
    disconnectedCallback() { document.removeEventListener('change', this.onChoice); }
    showPhoto(thumb) {
      this.main.removeAttribute('srcset');
      this.main.src = thumb.dataset.src;
      this.main.alt = thumb.dataset.alt;
      this.caption.textContent = thumb.dataset.alt;
      this.querySelectorAll('button[data-src]').forEach(b => b.setAttribute('aria-pressed', String(b === thumb)));
    }
    showOption() {
      const picker = this.closest('product-info').querySelector('variant-selects');
      const value = picker?.querySelector('input:checked, select option:checked')?.value.toLowerCase() || 'beige';
      const key = value.includes('pocket') ? 'pockets' : Object.keys(this.assets).find(k => value.includes(k));
      if (!key) return;
      this.dataset.key = key;
      const label = key === 'pockets' ? '5-piece pocket set — cover not included' : key[0].toUpperCase() + key.slice(1) + ' organizer book';
      const thumb = this.querySelector('[data-selected-photo]');
      thumb.dataset.src = this.assets[key]; thumb.dataset.alt = label;
      thumb.querySelector('img').src = this.assets[key];
      thumb.querySelector('img').alt = label;
      this.querySelectorAll('[data-book-photo]').forEach(b => b.hidden = key === 'pockets');
      this.showPhoto(thumb);
    }
  });
}
if (!customElements.get('aura-gallery')) {
  customElements.define('aura-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-image]');
        if (!button || !this.contains(button)) return;
        const main = this.querySelector('[data-aura-main]');
        main.removeAttribute('srcset');
        main.src = button.dataset.image;
        main.alt = button.dataset.alt;
        this.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      });
    }
  });
}
if (!customElements.get('aura-sticky')) {
  customElements.define('aura-sticky', class extends HTMLElement {
    connectedCallback() {
      const purchaseArea = document.querySelector('.aura-product .product-form__buttons');
      if (!purchaseArea || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting;
      }, { rootMargin: '-90px 0px -30px 0px', threshold: 0 });
      this.observer.observe(purchaseArea);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

/* Prefer Beige on a clean product URL and clearly identify the pocket-only option. */
const auraVariants = document.querySelector('.aura-product variant-selects');
if (auraVariants) {
  const variantQuery = new URLSearchParams(window.location.search).has('variant');
  const beige = [...auraVariants.querySelectorAll('input[type="radio"], option')]
    .find((item) => item.value.trim().toLowerCase() === 'beige');

  if (!variantQuery && beige) {
    if (beige.tagName === 'OPTION') {
      const select = beige.closest('select');
      if (select && select.value !== beige.value) {
        select.value = beige.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (!beige.checked) {
      beige.click();
    }
  }

  const updateAuraChoiceGuide = () => {
    const selected = document.querySelector('.aura-product variant-selects input[type="radio"]:checked, .aura-product variant-selects select option:checked');
    const value = selected?.value.toLowerCase() || '';
    const isPocketSet = value.includes('pocket');
    const note = document.querySelector('[data-aura-refill-note]');
    if (note) note.hidden = !isPocketSet;
  };

  document.addEventListener('change', (event) => {
    if (event.target.closest('.aura-product variant-selects')) updateAuraChoiceGuide();
  });
  updateAuraChoiceGuide();
}
